
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SingleSelectWithProportionGraphTypeV1 {
  export enum SingleSelectWithProportionGraphTypeV1 {
    PROPORTION = "PROPORTION",
    DONUT = "DONUT",
    PIE = "PIE",
    HORIZONTAL_BAR = "HORIZONTAL_BAR",
    VERTICAL_BAR = "VERTICAL_BAR",
    LINE = "LINE",
    LINE_AREA = "LINE_AREA",
    NONE = "NONE",
  }

  export interface SingleSelectWithProportionGraphTypeV1DTO {
    case: string;
  }

  export const fromDTO = (dto: SingleSelectWithProportionGraphTypeV1DTO): SingleSelectWithProportionGraphTypeV1 => {
    if (dto === undefined || dto === null) {
      throw new InvalidSingleSelectWithProportionGraphTypeV1Error(
        `Invalid DTO ${dto} provided for SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1`
      );
    }
    switch (dto.case) {
      case "PROPORTION":
        return SingleSelectWithProportionGraphTypeV1.PROPORTION;
      case "DONUT":
        return SingleSelectWithProportionGraphTypeV1.DONUT;
      case "PIE":
        return SingleSelectWithProportionGraphTypeV1.PIE;
      case "HORIZONTAL_BAR":
        return SingleSelectWithProportionGraphTypeV1.HORIZONTAL_BAR;
      case "VERTICAL_BAR":
        return SingleSelectWithProportionGraphTypeV1.VERTICAL_BAR;
      case "LINE":
        return SingleSelectWithProportionGraphTypeV1.LINE;
      case "LINE_AREA":
        return SingleSelectWithProportionGraphTypeV1.LINE_AREA;
      case "NONE":
        return SingleSelectWithProportionGraphTypeV1.NONE;
      default:
        throw new InvalidSingleSelectWithProportionGraphTypeV1Error(
          `Case ${dto.case} is not valid case of SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1`
        );
    }
  };

  export const toDTO = (singleSelectWithProportionGraphTypeV1: SingleSelectWithProportionGraphTypeV1): SingleSelectWithProportionGraphTypeV1DTO => {
    const enumDTO = {
      case: SingleSelectWithProportionGraphTypeV1[singleSelectWithProportionGraphTypeV1],
    };
    return enumDTO;
  };
}

export class InvalidSingleSelectWithProportionGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1Error";
  }
}
export class InvalidSingleSelectWithProportionGraphTypeV1ProportionError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1ProportionError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1DonutError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1DonutError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1PieError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1PieError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1HorizontalBarError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1HorizontalBarError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1VerticalBarError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1VerticalBarError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1LineError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1LineError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1LineAreaError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1LineAreaError";
  }
}

export class InvalidSingleSelectWithProportionGraphTypeV1NoneError extends InvalidSingleSelectWithProportionGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectWithProportionGraphTypeV1NoneError";
  }
}
